import React from 'react'

function DocumentNotFound() {

    return (
        <div className="errorpage">
            <p class="error"> A keresett dokumentum nem található, kérjük térjen vissza később vagy vegye fel a kapcsolatot velünk. </p>
        </div>
    )

}

export default DocumentNotFound;
